import React, { useState, useEffect } from "react";
import YouTube, { YouTubeProps } from "react-youtube";
import { videoCategoryListWrap, videoList } from "../../data/video";
import * as S from "./styled";
import AOS from "aos";

const Video = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [videoId, setVideoId] = useState<string>("");
  const [filteredVideos, setFilteredVideos] = useState(videoList);

  useEffect(() => {
    const filtered =
      selectedCategory === "all"
        ? videoList
        : videoList.filter((video) => video.category === selectedCategory);

    setFilteredVideos(filtered);
  }, [selectedCategory]);

  const onPlayerReady: YouTubeProps["onReady"] = (event) => {
    event.target.pauseVideo();
  };
  const [screenWidth, setScreenWidth] = useState<number>(0);
  const [yotubeWidth, setYoutubeWidth] = useState<number>(960);
  const [youtubeHeight, setYoutubeHeight] = useState<number>(600);

  const opts: YouTubeProps["opts"] = {
    width: yotubeWidth,
    height: youtubeHeight,
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
    },
  };

  useEffect(() => {
    const updateScrollHeight = () => {
      const screenWidth = window.innerWidth;
      setScreenWidth(window.innerWidth);
      if (screenWidth >= 1024) {
        setYoutubeWidth(960);
        setYoutubeHeight(600);
      } else if (screenWidth >= 640) {
        setYoutubeWidth(600);
        setYoutubeHeight(400);
      } else {
        setIsVideoOpen(false);
      }
    };

    updateScrollHeight();
    window.addEventListener("resize", updateScrollHeight);

    return () => {
      window.removeEventListener("resize", updateScrollHeight);
    };
  }, []);

  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  return (
    <S.VideoWrapper>
      <div className="inner">
        <S.VideoWrap>
          <S.VideoTitleWrap>
            <h3
              data-aos="fade-right"
              data-aos-duration={500}
              data-aos-easing="linear"
            >
              VIDEO
            </h3>
            <p
              data-aos="fade-right"
              data-aos-delay={200}
              data-aos-duration={500}
              data-aos-easing="linear"
            >
              수업영상
            </p>
          </S.VideoTitleWrap>
          <S.VideoCategoryListWrap
            data-aos="fade"
            data-aos-duration={500}
            data-aos-delay={200}
            data-aos-easing="linear"
          >
            <li
              className={`${selectedCategory === "all" ? "active" : ""}`}
              onClick={() => setSelectedCategory("all")}
            >
              All
            </li>
            {videoCategoryListWrap.map((item) => (
              <li
                key={item.category}
                className={`${
                  selectedCategory === item.category ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(item.category)}
              >
                {item.category}
              </li>
            ))}
          </S.VideoCategoryListWrap>
          <S.VideoListWrap>
            {filteredVideos.map((video, index) => (
              <li
                key={video.videoId}
                onClick={() => {
                  if (screenWidth > 640) {
                    setIsVideoOpen(true);
                    setVideoId(video.videoId);
                  } else {
                    window.open(video.link, "_blank");
                  }
                }}
                data-aos="fade-up"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <div>
                  <div className="img-wrap">
                    <img src={video.thumbImg} alt="logo" />
                  </div>
                  <div className="text-wrap">
                    <p>{video.title}</p>
                    <span>{video.desc}</span>
                  </div>
                </div>
              </li>
            ))}
          </S.VideoListWrap>

          {isVideoOpen && videoId !== "" && (
            <S.YoutubeModalWrap>
              <S.YoutubeModalDim
                onClick={() => {
                  setIsVideoOpen(false);
                  setVideoId("");
                }}
              />
              <YouTube videoId={videoId} opts={opts} onReady={onPlayerReady} />
            </S.YoutubeModalWrap>
          )}
        </S.VideoWrap>
      </div>
    </S.VideoWrapper>
  );
};

export default Video;
